import { render, staticRenderFns } from "./XmContactBackend.vue?vue&type=template&id=476d0d36&scoped=true"
import script from "./XmContactBackend.vue?vue&type=script&lang=js"
export * from "./XmContactBackend.vue?vue&type=script&lang=js"
import style0 from "./XmContactBackend.vue?vue&type=style&index=0&id=476d0d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476d0d36",
  null
  
)

export default component.exports